/* VoltEdge — global.js (no dependencies) */
(function () {
  'use strict';

  /* ---------- Sticky header shadow ---------- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('header--scrolled', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Reveal on scroll ---------- */
  var revealEls = document.querySelectorAll('[data-reveal]');
  if (revealEls.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    revealEls.forEach(function (el, i) {
      el.style.transitionDelay = Math.min(i % 4 * 70, 280) + 'ms';
      io.observe(el);
    });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var wrap = btn.closest('.qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    if (btn.dataset.qty === 'inc') val += 1;
    if (btn.dataset.qty === 'dec') val = Math.max(parseInt(input.min, 10) || 1, val - 1);
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart: auto submit on quantity change ---------- */
  var cartForm = document.getElementById('CartForm');
  if (cartForm) {
    var t;
    cartForm.addEventListener('change', function (e) {
      if (!e.target.matches('[data-cart-qty]')) return;
      clearTimeout(t);
      t = setTimeout(function () { cartForm.submit(); }, 350);
    });
  }

  /* ---------- Sort select ---------- */
  document.querySelectorAll('[data-sort-by]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* ---------- Countdown timers ---------- */
  document.querySelectorAll('[data-countdown]').forEach(function (cd) {
    var end = new Date(cd.dataset.end);
    var wrap = cd.closest('[data-countdown-wrap]') || cd;
    if (isNaN(end.getTime())) { wrap.style.display = 'none'; return; }
    var d = cd.querySelector('.cd-d'), h = cd.querySelector('.cd-h'),
        m = cd.querySelector('.cd-m'), s = cd.querySelector('.cd-s');
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) { wrap.style.display = 'none'; clearInterval(timer); return; }
      var sec = Math.floor(diff / 1000);
      if (d) d.textContent = pad(Math.floor(sec / 86400));
      if (h) h.textContent = pad(Math.floor(sec % 86400 / 3600));
      if (m) m.textContent = pad(Math.floor(sec % 3600 / 60));
      if (s) s.textContent = pad(sec % 60);
    }
    tick();
    var timer = setInterval(tick, 1000);
  });

  /* ---------- Money formatting ---------- */
  function formatMoney(cents, format) {
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function withDelims(num, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      var parts = (num / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return precision ? whole + decimal + parts[1] : whole;
    }
    switch ((format.match(placeholderRegex) || [])[1]) {
      case 'amount': value = withDelims(cents, 2); break;
      case 'amount_no_decimals': value = withDelims(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelims(cents, 0, '.'); break;
      default: value = withDelims(cents, 2);
    }
    return format.replace(placeholderRegex, value);
  }

  /* ---------- Product form: variants, price, media ---------- */
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var variantsTag = root.querySelector('[data-variants]');
    if (!variantsTag) return;
    var variants;
    try { variants = JSON.parse(variantsTag.textContent); } catch (err) { return; }

    var selects = root.querySelectorAll('[data-option-select]');
    var idInput = root.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var saveEl = root.querySelector('[data-save]');
    var atcBtn = root.querySelector('[data-atc]');
    var atcText = root.querySelector('[data-atc-text]');
    var availEl = root.querySelector('[data-availability]');
    var mainImg = root.querySelector('[data-main-image] img');
    var moneyFormat = root.dataset.money || '${{amount}}';
    var baseUrl = root.dataset.url || window.location.pathname;

    function currentVariant() {
      var selected = [];
      selects.forEach(function (s) { selected[parseInt(s.dataset.index, 10)] = s.value; });
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
    }

    function update() {
      var v = currentVariant();
      if (!v) {
        if (atcBtn) { atcBtn.disabled = true; }
        if (atcText) { atcText.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = v.id;

      if (priceEl) priceEl.textContent = formatMoney(v.price, moneyFormat);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (compareEl) {
        compareEl.textContent = onSale ? formatMoney(v.compare_at_price, moneyFormat) : '';
        compareEl.style.display = onSale ? '' : 'none';
      }
      if (saveEl) {
        if (onSale) {
          var pct = Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100);
          saveEl.textContent = 'Save ' + pct + '%';
          saveEl.style.display = '';
        } else {
          saveEl.style.display = 'none';
        }
      }
      var priceWrap = root.querySelector('[data-price-wrap]');
      if (priceWrap) priceWrap.classList.toggle('price--sale', !!onSale);

      if (atcBtn) atcBtn.disabled = !v.available;
      if (atcText) atcText.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (availEl) {
        availEl.textContent = v.available ? 'In stock and ready to ship' : 'Sold out';
        availEl.classList.toggle('in', v.available);
        availEl.classList.toggle('out', !v.available);
      }

      if (mainImg && v.featured_image && v.featured_image.src) {
        var src = v.featured_image.src.split('?')[0] + '?width=1200';
        mainImg.removeAttribute('srcset');
        mainImg.src = src;
      }

      try {
        var url = new URL(baseUrl, window.location.origin);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (err) { /* noop */ }
    }

    selects.forEach(function (s) { s.addEventListener('change', update); });
    if (selects.length) update();

    /* thumbnails */
    root.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.removeAttribute('srcset');
        mainImg.src = thumb.dataset.src;
        root.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  /* ---------- FAQ: optional single-open behaviour ---------- */
  document.querySelectorAll('[data-faq-single]').forEach(function (group) {
    group.addEventListener('toggle', function (e) {
      var item = e.target;
      if (item.tagName !== 'DETAILS' || !item.open) return;
      group.querySelectorAll('details[open]').forEach(function (other) {
        if (other !== item) other.open = false;
      });
    }, true);
  });

  /* ---------- Close drawers on Escape ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('details[data-drawer][open], details[data-search][open]').forEach(function (d) {
      d.open = false;
    });
  });
})();
